<template>
  <div class="new-input-box" v-loading="checkLoading">
    <input-form
      class="mb16"
      :inputData="myformInfo"
      @toParentVal="submitForm"
      :btnPosition1="true"
    ></input-form>
    <el-tooltip
      class="item"
      effect="dark"
      content="当前账号没有创建权限，请联系管理员添加。"
      placement="top"
      v-if="!permissions.includes('platform:benefit:create')"
    >
      <el-button disabled type="primary">创建任务</el-button>
    </el-tooltip>
    <el-button type="primary" v-else @click="createTasks">创建任务</el-button>
    <!-- <el-checkbox
      v-model="form.createByMe"
      style="margin-left: 20px"
      @change="handleCreateByMe"
      >我创建的</el-checkbox
    > -->
    <div class="new-table-box" style="margin-top: 12px">
      <el-table
        :data="tableData"
        v-loading="talbeLoading"
        style="width: 100%; border: 1px solid #f0f0f0;"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column prop="taskName" label="任务名称" width="200">
        </el-table-column>
        <el-table-column prop="planName" label="京东计划名称" width="200">
        </el-table-column>
        <el-table-column label="权益归属店铺" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.belongShopTitle || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantityPerIssue"
          label="发放京豆数量(每份)"
          width="200"
        >
        </el-table-column>
        <el-table-column prop="sendNum" label="预计发放数" width="200">
        </el-table-column>
        <el-table-column prop="successNum" label="实际发放数" width="200">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200">
        </el-table-column>
        <el-table-column label="完成时间" width="200">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.status === 0 || scope.row.status === 1
                  ? "-"
                  : scope.row.finishTime
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="任务状态" width="200">
          <template slot-scope="scope">
            <div>
              <jd-status :status="2" v-if="scope.row.status == 0"
                >待执行</jd-status
              >
              <jd-status :status="1" v-else-if="scope.row.status == 1"
                >执行中</jd-status
              >
              <jd-status :status="4" v-else-if="scope.row.status == 2"
                >执行结束</jd-status
              >
              <jd-status :status="4" v-else>已终止</jd-status>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="任务类型" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.type === 1 ? "定时发送" : "立即发送" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发送时间" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.sendTime || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.type === 1 && scope.row.status === 0"
              type="text"
              class="btn-style"
              @click="handleStop(scope.row)"
              >终止</el-button
            >
            <el-button
              type="text"
              class="btn-style"
              @click="checkDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              class="btn-style"
              type="text"
              @click="checkGrant(scope.row)"
              >发放明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="pagination-box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="text-align: right"
          :current-page="form.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="form.size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="numTotal"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="couponFromDisable ? '查看任务详情' : '批量发放京豆'"
      :visible.sync="couponDialogShow"
      @close="closeCouponDialog"
      width="1056px"
    >
      <el-form
        :model="couponFrom"
        label-width="135px"
        class="changeFrom"
        ref="couponFrom"
        :rules="couponFromRules"
        v-loading="lookLoading"
      >
        <el-form-item label="任务名称：" prop="taskName">
          <el-input
            v-model="couponFrom.taskName"
            style="width: 508px"
            placeholder="请输入"
            maxlength="30"
            show-word-limit
            :disabled="couponFromDisable"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务类型：" prop="type" required>
          <el-radio-group
            :disabled="couponFromDisable"
            v-model="couponFrom.type"
          >
            <el-radio :label="0">立即发送</el-radio>
            <el-radio :label="1">定时发送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="发送时间："
          prop="sendTime"
          v-if="couponFrom.type == 1"
        >
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              size="small"
              v-model="couponFrom.sendTime"
              :picker-options="pickerOptions2"
              :clearable="false"
              :disabled="couponFromDisable"
            >
            </el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearSendTime"
            ></i>
            <img
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
        </el-form-item>
        <el-form-item label="添加人群：" prop="selectCrowdType">
          <el-radio-group
            :disabled="couponFromDisable"
            v-model="couponFrom.selectCrowdType"
            @change="selectCrowdTypeChange"
          >
            <el-radio :label="2">输入pin</el-radio>
            <el-radio :label="3">导入pin</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="couponFrom.selectCrowdType == 2">
          <el-form-item label="输入pin：" prop="pinList">
            <el-input
              style="width: 450px"
              type="textarea"
              placeholder="请输入"
              v-model="couponFrom.pinList"
              :autosize="{ minRows: 4, maxRows: 6 }"
              :disabled="couponFromDisable"
            >
            </el-input>
            <div
              class="form_tip fz14"
              style="margin-top: 10px; line-height: 20px; width: 400px"
            >
              <div style="display: flex; align-items: center">
                <img
                  style="width: 16px; height: 16px"
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip_gray.jpg"
                />
                <span>注：1. 支持输入明文pin，每行一个用户pin；</span>
              </div>
              <div style="margin-left: 40px; margin-top: 5px">
                2.手动输入，一次输入最多支持2000行
              </div>
              <div style="margin-left: 40px; margin-top: 5px">
                3. 为避免用户pin重复导致多发情况，建议创建京豆时设置发放规则。
              </div>
            </div>
          </el-form-item>
        </template>
        <template v-if="couponFrom.selectCrowdType == 3">
          <el-form-item label="选择文件：" class="upload_item">
            <el-upload
              v-if="!couponFromDisable"
              ref="uploadFile"
              class="upload_box"
              :on-remove="removeFile"
              :file-list="fileList"
              action="#"
              :multiple="false"
              :limit="2"
              :show-file-list="true"
              :before-upload="beforeUpload"
              :http-request="httpUpload"
            >
              <el-button
                type="primary"
                :isZoom="true"
                zName="上传文件"
                label="上传文件"
                size="small"
              >
                点击上传文件
              </el-button>
            </el-upload>
            <div
              style="position: absolute; top: 0; left: 150px"
              v-if="!couponFromDisable"
            >
              <div>
                <i class="el-icon-loading" v-if="!uploadStatus"></i>
                <i
                  class="el-icon-success"
                  style="color: green"
                  v-if="uploadStatus === 1"
                ></i>
                <i
                  class="el-icon-error"
                  style="color: red"
                  v-if="uploadStatus === 2"
                ></i>
                <span v-if="!uploadStatus">上传中</span>
                <span v-if="uploadStatus === 1">上传成功</span>
                <span v-if="uploadStatus === 2">上传失败</span>
              </div>
            </div>
            <el-input
              v-model="couponFrom.fileUrl"
              style="display: none"
            ></el-input>
            <div v-if="couponFromDisable">{{ couponFrom.fileName }}</div>
          </el-form-item>
          <div
            class="form_tip"
            style="margin: 10px 0 25px 120px; width: fit-content; line-height: 20px"
            v-if="!couponFromDisable"
          >
            <div style="display: flex; align-items: center">
              <img
                style="width: 16px; height: 16px"
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip_gray.jpg"
              />
              <span
                >注：1. 下载模板后编辑: 支持输入明文pin；
                <a
                  v-if="couponFrom.selectCrowdType == 3"
                  target="_blank"
                  style="color: #7b61ff"
                  href="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E5%AF%BC%E5%85%A5%E6%89%B9%E9%87%8F%E5%8F%91%E6%94%BE%E6%A8%A1%E6%9D%BF.xlsx"
                  >点击下载模板</a
                >
              </span>
            </div>
            <div style="margin-left: 40px; margin-top: 10px">
              2. 支持csv、xls、xlsx格式上传，大小限制在50M内。
            </div>
            <div style="margin-left: 40px; margin-top: 10px; line-height: 25px">
              3. 为避免用户pin重复导致多发情况，建议创建京豆时设置发放规则。
            </div>
          </div>
        </template>
        <el-form-item
          label="选择京豆计划："
          v-if="!couponFromDisable"
          prop="label"
        >
          <el-select
            style="margin-right: 8px"
            v-model="accountCode"
            placeholder="请选择"
            v-if="selectedVenderType"
          >
            <el-option
              v-for="item in accountCodeList"
              :key="item.accountCode"
              :label="item.accountCode"
              :value="item.accountCode"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="couponFrom.label"
            placeholder="请选择"
            @change="planChange"
            style="width: 215px"
          >
            <el-option
              v-for="(item, index) in selectList"
              :key="index"
              :label="item.label"
              :value="item"
            ></el-option>
          </el-select>
          <el-button
            label=""
            @click="refreshJingdouList"
            type="text"
            class="btn-style ml8"
            >刷新</el-button
          >
          <el-button @click="jumpJingduo" class="btn-style ml8" type="text"
            >创建京豆计划</el-button
          >
          <!-- <el-popover
            placement="top-start"
            width="280"
            trigger="hover"
            :content="`请登录【${selectedShopName}】进行创建`"
          >
            <el-button
              slot="reference"
              type="text"
              :disabled="true"
              :styleTextObj="{ color: '#dfdfdf' }"
              >创建京豆计划</el-button
            >
          </el-popover> -->
          <div v-show="jingdouItem.sendTimes" style="font-size: 12px;">
            <span>计划剩余京豆</span>
            <span style="color: #fe4d45"> {{ jingdouItem.budgetRemain }} </span
            >个，
            <span
              >发豆次数：每人每天最多<span style="color: #fe4d45">{{
                jingdouItem.sendTimes
              }}</span
              >次</span
            >
          </div>
        </el-form-item>
        <el-form-item label="京豆计划名称：" v-if="couponFromDisable">
          {{ couponFrom.planName }}
        </el-form-item>
        <el-form-item label="发放京豆数量：">
          <div class="mb12">
            <el-input
              @input.native="checkputn"
              :disabled="couponFromDisable"
              v-model="couponFrom.quantityPerIssue"
              style="width: 215px"
            ></el-input>
            <span style="margin-left: 8px;" class="new_dou"
              >个京豆 （每人每次发送的京豆个数）</span
            >
          </div>
          <jd-tips>
            <p>注：</p>
            <p>
              因官方接口限制，如选择的京豆计划单次发放类型上限为1000时，超过会多次发放，为确保发放成功，京豆计划发放次数必须大于等于单份奖励个数/1000；
            </p>
            <p>
              如需发放超过1000建议选择单次发放类型上限为50000的京豆计划，如超过50000，也会多次发放；
            </p>
          </jd-tips>
          <div
            class="topTis"
            v-if="venderType && !isOpenJinDou"
            style="font-size: 12px"
          >
            <i
              class="el-icon-warning"
              style="color: #7b61ff; marginright: 8px; font-size: 12px"
            ></i>
            <div class="desc" style="color: #666">
              <p>自营店铺京豆使用流程：</p>
              <p class="topTis_line">1、开通白名单、账号授权</p>
              <p class="topTis_line">
                因京东平台对自营店铺充值有白名单限制，需要联系京东采销协助开通，请自营店铺在使用京豆前查看供应商充值操作流程。
              </p>
              <p
                class="topTis_line"
                style="color: #fe4d45; margin-bottom: 16px; cursor: pointer"
                @click="toJdTeach"
              >
                自营店铺京豆充值教程 >
              </p>
              <p class="topTis_line">2、绑定供应商简码、授权账号pin</p>
              <p class="topTis_line">
                如果供应商白名单，账号授权已经完成，请点击绑定供应商简码、授权账号pin；
              </p>
              <p class="topTis_line">
                绑定成功后需要重新进入活动页面，创建京豆计划。
              </p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="权益归属店铺：" v-if="couponFromDisable">
          {{ couponFrom.shopTitle }}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!couponFromDisable">
        <el-button type="primary" @click="batchCouponSure">确认</el-button>
        <el-button @click="closeCouponDialog">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="发放明细" :visible.sync="detailDialogShow" width="900px">
      <div class="detail_tip" v-loading="detailLoading">
        <div style="font-size: 18px; margin-bottom: 28px">京豆发放信息</div>
        <div
          style="
            margin-bottom: 10px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
          "
        >
          <span style="min-width: 205px; margin-bottom: 20px; margin-right: 5px"
            >京豆名称：{{ grant.planName }}</span
          >
          <span style="min-width: 205px; margin-bottom: 20px; margin-right: 5px"
            >权益归属店铺：{{ grant.shopTitle }}</span
          >
          <span style="min-width: 205px; margin-bottom: 20px; margin-right: 5px"
            >计划京豆总量：{{ grant.quantityTotal }}</span
          >
          <span style="min-width: 205px; margin-bottom: 20px; margin-right: 5px"
            >已发放京豆数量：{{ grant.budgetRemain }}</span
          >
          <span style="min-width: 205px; margin-bottom: 20px"
            >已发放人数：{{ grant.successNum }}</span
          >
        </div>
      </div>
      <input-form
        class="mb16"
        :inputData="detailFromInfo"
        @toParentVal="distributionBeansSure"
        :btnPosition1="true"
      ></input-form>
      <el-table
        style="width: 100%; border: 1px solid #f0f0f0;"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        :data="detailtableData"
        v-loading="detailtalbeLoading"
      >
        <el-table-column label="用户pin">
          <template slot-scope="scope">
            <div v-if="scope.row.customerPin && scope.row.customerPin != ''">
              <span class="pinBody" v-if="!scope.row.isShow">
                <span class="pintitle">{{ scope.row.chaosPin }}</span>
                <el-button
                  class="pinBu"
                  @click="showPin(scope.$index)"
                  type="text"
                  >显示全部</el-button
                >
              </span>
              <span v-else>{{ scope.row.customerPin }}</span>
            </div>
            <!-- customerPin为空的话使用mixPin -->
            <div v-else>
              <span class="pinBody" v-if="!scope.row.isShow">
                <span class="pintitle">{{ scope.row.chaosPin }}</span>
                <el-button
                  class="pinBu"
                  @click="showPin(scope.$index)"
                  type="text"
                  >显示全部</el-button
                >
              </span>
              <span v-else>{{ scope.row.mixPin }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sendTime" label="发放时间"></el-table-column>
        <el-table-column label="发放状态">
          <template slot-scope="scope">
            <div
              v-if="!scope.row.sendStatus"
              style="display: flex; align-items: center"
            >
              <jd-status :status="3">发放失败</jd-status>
              <el-tooltip :content="scope.row.failReason" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <div v-else><jd-status :status="0">发放成功</jd-status></div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="pagination-box">
        <el-pagination
          background
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          style="text-align: right"
          :current-page="detailFrom.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="detailFrom.size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="detailTotal"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import jdTips from "@/components/common/jdTips.vue";
import inputForm from "@/components/inputForm";
import jdStatus from "@/components/StatusTable/index.vue";
import {
  isauth,
  getSupplierAccountList,
  jignduoEcho,
  jingdouList,
} from "@/api/integralCenter/prizeCenter.js";
import {
  createTask,
  queryTaskPage,
  uploadFile,
  queryRecordPage,
  stopTask,
  getTaskDetail,
} from "@/api/integralCenter/batchDistributionBenefits.js";
export default {
  name: "batchBeans",
  components: {
    inputForm,
    jdStatus,
    jdTips,
  },
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lookLoading: false,
      detailLoading: false,
      myformInfo: [
        {
          name: "任务昵称：",
          val: "taskName",
          placeholder: "请输入",
        },
        {
          name: "任务状态：",
          val: "status",
          defaultValue: "",

          selectArr: [
            { label: "全部", id: "" },
            { label: "待执行", id: 0 },
            { label: "执行中", id: 1 },
            { label: "执行结束", id: 2 },
            { label: "已终止", id: 3 },
          ],
        },
        {
          name: "创建时间：",
          val: "createTime",
          myDate: true,
          val: ["createTimeStart", "createTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "任务类型：",
          val: "type",
          defaultValue: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "立即发送", id: 0 },
            { label: "定时发送", id: 1 },
          ],
        },
      ],
      couponFromRules: {
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
        ],
        selectCrowdType: [
          { required: true, message: "请选择添加人群类型", trigger: "blur" },
        ],
        sendTime: [
          { required: true, message: "请选择发送时间", trigger: "blur" },
        ],
        pinList: [
          { required: true, message: "请输入pin", trigger: "blur" },
        ],
      },
      isOpenJinDou: false,
      formAccount: {
        accountCode: "",
        accountType: "",
      },
      accountCode: "商家账户",
      accountCodeList: [],
      couponDialogShow: false,
      selectCouponShow: false,
      detailDialogShow: false,
      form: {
        taskName: "",
        status: "",
        createTimeStart: "",
        createTimeEnd: "",
        sendType: 2,
        current: 1,
        size: 10,
        // createByMe: false,
        type: "",
      },
      pickerOptions2: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
        },
        // selectableRange:
        //   new Date().getHours() +
        //   ":" +
        //   (new Date().getMinutes() + 1) +
        //   ":00" +
        //   " - 23:59:59",
      },
      tableData: [],
      talbeLoading: false,
      numTotal: 0,
      couponFrom: {
        taskName: "",
        type: 0,
        sendTime: "",
        selectCrowdType: 2,
        pinList: "",
        fileName: "",
        fileUrl: "",
        planId: "",
        planName: "",
        quantityPerIssue: "",
        planToken: "",
      },
      selectList: [],
      jingdouItem: {
        sendTimes: "",
        budgetRemain: "",
      },
      couponFromDisable: false,
      coupon: {
        couponDetail: "",
        couponId: "",
        couponName: "",
        takeBeginTime: "",
        takeEndTime: "",
        validity: "",
        validityType: "",
        addDays: "",
      },
      fileList: [],
      amountDisabled: true,
      tradeCountDisabled: true,
      goodsStateLength1: 0,
      goodsStateLength2: 0,
      isShowSelectGoods: false,
      goodsStateLength: 0,
      goodsState: false,
      selectGoodsSkuList: [],
      selectCouponForm: {
        name: "",
        couponIdOrPutKey: "",
        status: "",
        couponKind: "",
        beginTime: this.getDateStr(-30) + " 00:00:00",
        endTime: this.getDateStr(0) + " 23:59:59",
        current: 1,
        size: 10,
      },
      pickerOptions5: {
        disabledDate: (time) => {
          if (this.selectCouponForm.endTime) {
            return (
              time.getTime() > new Date(this.selectCouponForm.endTime).getTime()
            );
          }
        },
      },
      pickerOptions6: {
        disabledDate: (time) => {
          if (this.selectCouponForm.beginTime) {
            return (
              time.getTime() <
              new Date(this.selectCouponForm.beginTime).getTime()
            );
          }
        },
      },
      couponFromBtnLoading: false,
      coupontableData: [],
      coupontalbeLoading: false,
      couponTotal: 0,
      YunqiForm: {
        searchKey: "",
        source: "",
        current: 1,
        size: 10,
      },
      YunqiFormInfo: [
        {
          label: "人群信息：",
          prop: "searchKey",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "生成渠道：",
          prop: "source",
          type: "Select",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "手动导入", value: "1" },
            { label: "客户标签生成", value: "2" },
            { label: "权益发放生成", value: "3" },
            { label: "订单生成", value: "4" },
            { label: "营销画布生成", value: "5" },
            { label: "京东人群转化", value: "6" },
            { label: "互动生成", value: "7" },
            { label: "数据中心生成", value: "8" },
            { label: "京获客生成", value: "9" },
            { label: "云起标签生成", value: "10" },
          ],
        },
      ],
      tableInfo2: [
        {
          label: "用户pin",
          prop: "chaosPin",
          width: 200,
          slot: "chaosPin", // 自定义插槽用于处理 chaosPin / customerPin / mixPin 的显示逻辑
        },
        {
          label: "发放时间",
          prop: "sendTime",
        },
        {
          label: "发放状态",
          prop: "sendStatus",
          slot: "sendStatus", // 插槽中用于显示状态 + tooltip
        },
      ],
      YunqiTableInfo: [
        {
          label: "人群名称",
          prop: "name",
          width: 100,
        },
        {
          label: "生成渠道",
          prop: "source",
          width: 100,
          slot: "source", // 通过 slot 映射 source -> 渠道中文名
        },
        {
          label: "人群数量",
          prop: "number",
          width: 100,
          align: "right",
        },
        {
          label: "人群描述",
          prop: "description",
          minWidth: 150,
        },
        {
          label: "创建时间",
          prop: "createTime",
          width: 200,
        },
        {
          label: "权益发放人群可用状态",
          prop: "status",
          width: 200,
          slot: "status", // 自定义颜色 icon + tooltip
        },
        {
          label: "互动活动人群可用状态",
          prop: "hdStatus",
          slot: "hdStatus", // 自定义点击生成 / 状态文案 / 图标 + tooltip
          width: 200,
        },
      ],
      yunqiTotal: 0,
      yunqiTableData: [],
      yunqiTableLoading: false,
      detailFrom: {
        customerPin: "",
        sendStatus: "",
        sendType: 2,
        size: 10,
        current: 1,
      },
      detailFromInfo: [
        {
          name: "用户pin：",
          val: "customerPin",
          placeholder: "请输入",
        },
        {
          name: "发放状态：",
          val: "sendStatus",
          defaultValue: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "发放成功", id: 0 },
            { label: "发放失败", id: 1 },
          ],
        },
      ],
      detailtableData: [],
      detailTotal: 0,
      detailtalbeLoading: false,
      total: 0,
      uploadStatus: -1,
      checkLoading: false,
      grant: {
        planName: "",
        quantityTotal: "",
        budgetRemain: "",
        successNum: "",
      },
      peopleDialogShow: false,
      peopleFrom: {
        crowdName: "",
        crowdDescription: "",
        crowdType: [],
        isBuildJdCrowd: false,
        isBuildHdCrowd: false,
      },
      peopleRules: {
        crowdName: [
          { required: true, message: "请输入人群名称", trigger: "blur" },
        ],
        crowdDescription: [
          { required: true, message: "请输入人群描述", trigger: "blur" },
        ],
        crowdType: [
          { required: true, message: "请选择生成人群类型", trigger: "change" },
        ],
      },
      condition: {},
      shopList: [], // 店铺列表
      planLoading: false, // 计划加载中
    };
  },
  watch: {
    venderType: {
      handler(newVal) {
        if (newVal) {
          this.getSupplierList();
        }
      },
      immediate: true,
    },
    accountCode: {
      handler(newVal) {
        if (newVal) {
          if (newVal == "商家账户") {
            this.formAccount.accountCode = this.currentShopId;
            this.formAccount.accountType = "1";
          } else {
            this.formAccount.accountCode = newVal;
            this.formAccount.accountType = "2";
          }
        }
        this.couponFrom.label = "";
        this.jingdouItem.budgetRemain = "";
        this.jingdouItem.sendTimes = "";
        this.getJingdouList();
      },
      immediate: true,
    },
    // "couponFrom.sendTime"(selectTime) {
    //   const date = new Date(
    //     new Date(selectTime).setHours(0, 0, 0, 0)
    //   ).getTime();
    //   const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
    //   if (date == today) {
    //     // 当选择的日期就是当天的时候，这个时候就要限制时间应当小于此时此刻的时分秒
    //     this.pickerOptions2.selectableRange =
    //       new Date().getHours() +
    //       ":" +
    //       (new Date().getMinutes() + 1) +
    //       ":00" +
    //       " - 23:59:59";
    //   } else {
    //     // 当选择的日期小于当天的时候，这时需要把时分秒的限制放开，否则不能选择
    //     this.pickerOptions2.selectableRange = "00:00:00 - 23:59:59";
    //   }
    // },
  },
  computed: {
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    },
    currentShopId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    sendTimeLimit() {
      return new Date(this.couponFrom.sendTime).getTime() < Date.now();
    },
    // 当前所处的店铺标题
    currentShopTitle() {
      return this.$store.getters.loginUserInfo.sellerNick;
    },
    // 当前下拉选择的店铺是否为自营
    selectedVenderType() {
      let venderType = false;
      this.shopList.forEach((item) => {
        if (item.value == this.currentShopId) {
          venderType = item.venderType;
        }
      });
      return venderType;
    },
  },
  mounted() {
    this.getIsauth();
    this.getBenefitList();
    // this.getShopList();
  },

  methods: {
    closeIntegralDialog() {
      this.grant = {
        planName: "",
        quantityTotal: "",
        budgetRemain: "",
        successNum: "",
      };
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.getBenefitList();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.getBenefitList();
    },
    handleSizeChange2(val) {
      this.detailFrom.size = val;
      this.getRecordList();
    },
    handleCurrentChange2(val) {
      this.detailFrom.current = val;
      this.getRecordList();
    },
    YunqiFormFun(data) {
      this.YunqiForm = {
        searchKey: data.searchKey || "",
        source: data.source,
        current: 1,
        size: 10,
      };
      this.getYyunQiCrowd();
    },
    showPin(index) {
      this.detailtableData[index].isShow = true;
    },
    changeShop() {
      this.couponFrom.label = "";
      this.jingdouItem = {
        sendTimes: "",
        budgetRemain: "",
      };
      // 如果是自营店再请求账户接口
      if (this.selectedVenderType) {
        this.accountCode = "";
        this.getSupplierList();
      }
      this.getJingdouList();
    },
    selectCrowdTypeChange() {
      if (this.$refs["couponFrom"]) {
        this.$refs["couponFrom"].clearValidate();
      }
    },
    clearSendTime() {
      this.couponFrom.sendTime = "";
    },
    // 京豆充值教程
    toJdTeach() {
      window.open(
        "https://www.yuque.com/yunduanxincrm/flgan6/wm6y952zt56lgu6b"
      );
    },
    // 查询是否开通京豆计划
    async getIsauth() {
      const res = await isauth();
      if (res.code == 1) {
        this.isOpenJinDou = res.data;
      } else {
        this.isOpenJinDou = false;
      }
    },
    async getSupplierList() {
      try {
        const res = await getSupplierAccountList({
          venderId: this.currentShopId,
        });
        if (res.code == 1) {
          let list = res.data;
          this.accountCodeList = list.map((item) => {
            let obj = {};
            obj["accountCode"] = item;
            return obj;
          });
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          });
        } else {
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          });
        }
      } catch (error) {}
    },
    isToTenMin(sendTime, delay) {
      let time1 = new Date(sendTime).getTime();
      let time2 = Date.now();
      let time3 = time1 - time2;
      return (time3 * 1) / (1000 * 60) < delay * 1;
    },
    handleStop(row) {
      this.$confirm("您确定要终止任务吗? 终止后任务将不会执行", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        if (this.isToTenMin(row.sendTime, 10)) {
          return this.$message.error("距离发送时间不足10分钟，无法取消发送哦");
        }
        stopTask(row.id).then((res) => {
          if (res.code == "1") {
            this.$message.success(res.message);
            this.getBenefitList();
          } else {
            return this.$message.error(res.message);
          }
        });
      });
    },
    // handleCreateByMe() {
    //   this.form.current = 1;
    //   this.getBenefitList();
    // },
    getBenefitList() {
      this.talbeLoading = true;
      queryTaskPage(this.form).then((res) => {
        this.tableData = res.data.records;
        this.talbeLoading = false;
        this.numTotal = +res.data.total;
      });
    },
    submitForm(data) {
      this.form = {
        ...this.form,
        taskName: data.taskName || "",
        status: data.status,
        createTimeStart: data.createTimeStart || "",
        createTimeEnd: data.createTimeEnd || "",
        type: data.type,
        sendType: 2,
        current: 1,
        size: 10,
      };
      this.getBenefitList();
    },
    closeCouponDialog() {
      this.couponFrom = {
        taskName: "",
        type: 0,
        selectCrowdType: 2,
        pinList: "",
        fileName: "",
        fileUrl: "",
        planId: "",
        planName: "",
        quantityPerIssue: "",
        planToken: "",
      };
      this.jingdouItem = {
        sendTimes: "",
        budgetRemain: "",
      };
      this.uploadStatus = -1;
      this.fileList = [];
      this.$refs.couponFrom.clearValidate();
      this.couponDialogShow = false;
    },
    confirmCoupon(row) {
      console.log(row);
      if (row.couponKind == 0) {
        this.coupon.couponDetail = `全品类东券,满${row.quota}减${row.discount}`;
      }
      if (row.couponKind == 1) {
        this.coupon.couponDetail = `限品类京券,满${row.quota}减${row.discount}`;
      }
      if (row.couponKind == 2) {
        this.coupon.couponDetail = `店铺东券,满${row.quota}减${row.discount}`;
      }
      if (row.couponKind == 3) {
        this.coupon.couponDetail = `限商品东券,满${row.quota}减${row.discount}`;
      }
      this.coupon.couponId = row.couponId;
      this.coupon.couponName = row.name;
      this.coupon.takeBeginTime = row.takeBeginTime;
      this.coupon.takeEndTime = row.takeEndTime;
      this.coupon.addDays = row.addDays;
      this.coupon.validityType = row.validityType;
      if (row.validityType == 5) {
        this.coupon.validity = `${row.takeBeginTime} 至 ${row.takeEndTime}`;
      } else {
        this.coupon.validity = `领取后${row.addDays}天有效`;
      }
      this.selectCouponShow = false;
    },
    async batchCouponSure() {
      try {
        await this.$refs.couponFrom.validate();
        if (this.couponFrom.type == 1 && this.sendTimeLimit) {
          return this.$message.warning(
            "发送时间不能设置为过去的时间，请重新设置"
          );
        }
        if (!this.couponFrom.label) {
          return this.$message.warning("请选择京豆计划");
        }
        let params = {
          taskName: this.couponFrom.taskName,
          sendType: 2,
          type: this.couponFrom.type,
          sendTime: this.couponFrom.sendTime,
          selectCrowdType: this.couponFrom.selectCrowdType,
          planId: this.couponFrom.planId,
          planName: this.couponFrom.planName,
          quantityPerIssue: this.couponFrom.quantityPerIssue,
          planToken: this.couponFrom.planToken,
          belongVenderId: this.currentShopId,
          belongShopTitle: this.currentShopTitle,
        };
        if (this.couponFrom.selectCrowdType == 2) {
          params.pinList = this.couponFrom.pinList.split("\n");
        } else if (this.couponFrom.selectCrowdType == 3) {
          params.fileName = this.couponFrom.fileName;
          params.fileUrl = this.couponFrom.fileUrl;
        } else if (this.couponFrom.type == 0) {
          delete params.sendTime;
        }
        this.couponFromBtnLoading = true;
        createTask(params).then((res) => {
          if (res.code == 1) {
            this.closeCouponDialog();
            this.$message.success("添加成功");
            this.getBenefitList();
          } else {
            this.$message.warning(res.message);
          }
          this.couponFromBtnLoading = false;
        });
      } catch (error) {}
    },
    removeFile(file, fileList) {
      console.log(file, fileList);
      this.couponFrom.fileUrl = "";
      this.couponFrom.fileName = "";
      this.uploadStatus = -1;
      this.fileList = [];
    },
    beforeUpload(file) {
      if (file.size / 1024 / 1024 > 50) {
        this.$message.warning("文件不得超过50M");
        return false;
      }
      if (
        file.type !=
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type != "application/vnd.ms-excel" &&
        file.type != "text/csv"
      ) {
        this.$message.warning("请上传正确格式的文件");
        return false;
      }
    },
    httpUpload({ file }) {
      console.log("file------------------", file);
      this.removeFile();
      let formData = new FormData();
      formData.append("file", file);
      this.uploadStatus = 0;
      console.log(formData);
      uploadFile(formData, 5).then((res) => {
        console.log("上传文件------------------", res);
        if (res.code == 1) {
          this.uploadStatus = 1;
          this.couponFrom.fileUrl = res.data.fileUrl;
          this.couponFrom.fileName = file.name;
          this.fileList = [{ name: file.name, url: res.data.fileUrl }];
        } else {
          this.uploadStatus = 2;
        }
      });
    },
    createTasks() {
      this.couponDialogShow = true;
      this.couponFromDisable = false;
    },
    checkDetail(row) {
      this.couponDialogShow = true;
      this.lookLoading = true;
      getTaskDetail(row.id)
        .then((res) => {
          this.lookLoading = false;
          if (res.code == 1) {
            this.couponFromDisable = true;
            this.couponFrom.taskName = res.data.taskName;
            this.couponFrom.type = res.data.type;
            this.couponFrom.sendTime = res.data.sendTime;
            this.couponFrom.selectCrowdType = res.data.selectCrowdType;
            this.couponFrom.planName = res.data.planName;
            this.couponFrom.quantityPerIssue = res.data.quantityPerIssue;
            this.couponFrom.shopTitle = row.belongShopTitle;
            if (res.data.selectCrowdType == 3) {
              this.couponFrom.fileName = res.data.fileName;
              this.couponFrom.fileUrl = res.data.fileUrl;
            }
            if (res.data.selectCrowdType == 2) {
              this.couponFrom.pinList = res.data.pinList.join("\n");
            }
          }
        })
        .catch(() => {
          this.lookLoading = false;
        });
    },
    checkGrant(row) {
      this.detailDialogShow = true;
      this.detailLoading = true;
      jignduoEcho(row.planId)
        .then((res) => {
          this.detailLoading = false;
          this.grant.planName = res.data.planName;
          this.grant.quantityTotal = +res.data.quantityTotal;
          this.grant.budgetRemain = row.quantityPerIssue * row.successNum;
          this.grant.successNum = row.successNum;
          this.grant.shopTitle = row.belongShopTitle;
          this.detailFrom.id = row.id;
          this.getRecordList();
        })
        .catch(() => {
          this.detailLoading = false;
        });
    },
    getRecordList() {
      this.detailtalbeLoading = true;
      queryRecordPage(this.detailFrom).then((res) => {
        this.detailtalbeLoading = false;
        let detailtableData = res.data.records;
        detailtableData.forEach((item) => {
          item.isShow = false;
        });
        this.detailtableData = detailtableData;
        this.detailTotal = +res.data.total;
      });
    },
    distributionBeansSure(data) {
      this.detailFrom = {
        ...this.detailFrom,
        customerPin: data.customerPin || "",
        sendStatus: data.sendStatus,
        sendType: 3,
        size: 10,
        current: 1,
      };
      this.getRecordList();
    },
    refreshJingdouList() {
      this.accountType = "1";
      this.accountCode = "";
      this.getJingdouList();
    },
    getJingdouList() {
      this.selectList = [];
      this.planLoading = true;
      jingdouList({
        activityId: "",
        current: 1,
        idList: [],
        isFilterUsed: true,
        size: 100,
        status: 4,
        accountCode: this.selectedVenderType
          ? this.formAccount.accountCode
          : undefined,
        venderId: this.currentShopId,
      })
        .then((res) => {
          let selectArr = res.data.records.map((item) => {
            return {
              label: item.planName,
              value: item.id,
              sendTimes: item.sendTimes,
              budgetRemain: item.budgetRemain, // 金豆计划剩余数量
              planToken: item.planToken,
            };
          });
          this.selectList = selectArr;
          this.planLoading = false;
        })
        .catch((res) => {});
    },
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        tabAct: 1,
      });
      window.open(routeUrl.href, "_blank");
    },
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    planChange(val) {
      console.log(val);
      console.log(this.selectList);
      this.jingdouItem.budgetRemain = val.budgetRemain;
      this.jingdouItem.sendTimes = val.sendTimes;
      this.couponFrom.planId = val.value;
      this.couponFrom.planName = val.label;
      this.couponFrom.planToken = val.planToken;
    },
  },
};
</script>
<style lang="scss" scoped>
.fz14 {
  font-size: 14px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}

.goodsselect_button {
  width: 145px;
  height: 32px;
  background: #f5f5f7;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  display: block;
  cursor: pointer;
  padding: 0 10px;
  border-radius: 2px;
  color: #333333;
  margin-left: 8px;
}

::v-deep .formitem_flex .el-form-item__content {
  display: flex;
  align-items: center;
}

.form_tip {
  width: 300px;
  background-color: #f4f4f5;
  padding: 8px 12px;
  font-size: 14px;
}

::v-deep .upload_item .el-form-item__content {
  position: relative;
  display: flex;
}

.detail_tip {
  background-color: #f4f4f5;
  padding: 12px;
  margin-bottom: 18px;
}

.select_goods {
  ::v-deep .el-form-item__content {
    margin-left: 0px !important;
    display: flex;
    align-items: center;
  }
}

.imgs {
  width: 14px;
  vertical-align: middle;
  margin-right: 6px;
  margin-top: -2px;
}

.topTis {
  display: flex;
  align-items: baseline;
  color: #333;
  font-size: 14px;
  background: #f4f7ff;
  margin: 24px;
  padding: 12px;
  color: #333;
  margin-left: 0px;
  .desc {
    line-height: 20px;
  }
  p {
    margin-left: 5px;
    line-height: 20px;
  }
  .topTis_line {
    line-height: 25px;
    font-size: 12px;
  }
}
.pinBody {
  .pintitle {
    display: block;
  }
  .pinBu {
    display: none;
  }
  &:hover {
    .pintitle {
      display: none;
    }
    .pinBu {
      display: block;
    }
  }
}
.new_dou {
  font-size: 14px;
}
.mb12 {
  margin-bottom: 12px;
}
.btn-style {
  padding: 0 !important;
  width: auto;
}
.ml8 {
  margin-left: 8px;
}
</style>
